<template>
  <!-- BESPOKE ROD: Added v-if="filters.length" -->
  <div v-if="filters.length" class="cmp-elastic-product-filters utlz-reset col-md-12">
    <!-- END BESPOKE ROD -->
    
    
    <transition name="slide-fade">
      <div v-if="showMobileFilters" class="filters-container" :ref="'filters-container'">

        <a v-if="showMobileFilters" @click="toggleMobileFilters()" class="close-filters-btn show-mobile">
          <i class="fa fa-times"></i>
        </a>
        
        <!-- BESPOKE -->
        <template v-if="hasActiveFilters">
          <span class="clear-filters-btn" @click="clearFilters">
            <i class="fa fa-times-circle"></i>
            <span v-translation="{ type: 'button', code: 'button_clear_filters' }"></span>
          </span>
        </template>
        <!-- END BESPOKE -->

        <div v-for="(filterGroup, i) in filters" :key="'filter-group-' + i" class="filters-wrapper">
          <div class="filter-header">
            <!-- BESPOKE: CHanged h2 to h3 -->
            <h3>{{ filterGroup.label }}</h3>
            <!-- END BESPOKE -->
            <!-- BESPOKE ROD: Added fa.angle-down -->
            <!-- <i class="dd-arrow fa fa-angle-down"></i> -->
            <!-- END BESPOKE ROD -->
          </div>
          <div class="filter-content">
            <!-- BESPOKE GOOL: Changed 5 to 999 -->
            <ul :ref="'filter-group-list' + i" :class="{ collapsed: filterGroup.value.length > 999 }">
            <!-- END BESPOKE GOOL -->
              <li v-for="(filterObj, id) in filterGroup.value" :key="'filter-group-item-' + id">
                <div class="checkbox-group">
                  <input type="checkbox" :id="'checkbox-filter-' + filterGroup.id + '-' + filterObj.key" @change="checkedFilter($event, { id: filterGroup.id, value: filterObj.key, elemId: 'checkbox-filter-' + filterGroup.id + '-' + filterObj.key })" :checked="filterObj.active === true">
                  <label :for="'checkbox-filter-' + filterGroup.id + '-' +  filterObj.key">
                    <span class="key">
                      {{ getDisplayValue(filterObj) }}
                    </span>
                    <!-- BESPOKE -->
                    <!-- <span class="count">
                      ({{ filterObj.value }})
                    </span> -->
                    <!-- END BESPOKE -->
                  </label>
                </div>
              </li>
            </ul>
            <!-- BESPOKE GOOL: Changed 5 to 999 -->
            <div v-if="filterGroup.value.length > 999" class="collapse-btns" @click="collapseList('filter-group-list' + i)">
            <!-- END BESPOKE GOOL -->
              <div class="show-more-btn">
                <span class="text-link">
                  <i class="fa fa-angle-double-down"></i>
                  <span v-translation="{ type: 'label', code: 'label_filter_collapse_more' }"></span>
                </span>
                <span class="total-collapsed count">({{ filterGroup.value.length - 5 }})</span>
              </div>
              <div class="show-less-btn">
                <span class="text-link">
                  <i class="fa fa-angle-double-up"></i>
                  <span v-translation="{ type: 'label', code: 'label_filter_collapse_less'}"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  // BESPOKE ROD
  data() {
    return {
      movedFilters: false
    }
  },
  // END BESPOKE ROD
  computed: {
    ...mapState('elastic', ['filters']),
    // BESPOKE ROD
    // Added hasActiveFilters
    ...mapGetters('elastic', ['showMobileFilters', 'hasActiveFilters'])
  },
  // BESPOKE ROD
    // Added clearFilters
  methods: {
    ...mapActions('elastic', ['updateFilters', 'toggleMobileFilters', 'clearFilters']),
    checkedFilter (ev, filter) {
      const payload = {
        filterActive: ev.target.checked,
        filterId: filter.id,
        filterValue: filter.value
      };
      if (ev.target.checked) {
        document.getElementById(filter.elemId).checked = false;
      } else {
        document.getElementById(filter.elemId).checked = true;
      }
      this.updateFilters(payload);
    },
    collapseList ($event) {
      this.$refs[$event][0].classList.toggle('collapsed');
    },
    // BESPOKE
    getDisplayValue(valObj) {
      if (valObj.translation != undefined) {
        return valObj.translation;
      } else {
        return valObj.key;
      }
    }  
    // END BESPOKE
  },
  // BESPOKE ROD
  // Move product filters to a different position
  updated() {
    if (!this.movedFilters) {
      $('#ph-product-filters').append($('.cmp-elastic-product-filters'));
      this.movedFilters = true;
    }
  }
  // END BESPOKE ORD
}
</script>
<style>

</style>
